import styled from 'styled-components'

export const CPBPOMContainer = styled.div`
  font-family: Outfit;
  margin: 8px 8px 0 8px;
  border-radius: 1.5rem;
  background: #fafafa;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 100px);
  @media print {
    background: unset;
  }
  @media (min-width: 768px) {
    padding: 16px;
    margin: 16px 16px 0 16px;
  }
`

export const CPBPOMBookAndPayButton = styled.button`
  background: #7154b0;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s ease-in-out;
  scale: 1;
  padding: 10px 24px;
  border-radius: 16px;
  &:active {
    scale: 0.9;
  }
`
